import ApiStocks from "../../Services/ApiStocks";
import ApiService from "../../Services/ApiService";

export default {
    state: {
        userScreeners: [],
        screeners: [],
        array_data_screener: [],
        screenerFilters: {
            ticker: '',
            name: '',
            sales: {
                displayOption: "number"
            }
        },
        temporaryFilterValues: {},
        optionQorFY: 'Q',
        exchangeSelections: [
            { swedens: [] },
            { filands: [] },
            { norways: [] },
            { denmarks: [] }
        ],
        sectorSelections: [],
        orderOfColumns: ['sales_growth', 'ps', 'pe', 'stock_exchange_id', 'sector_id', 'sales', 'name', 'ticker']
    },

    getters: {
        getUserScreeners(state) {
            return state.userScreeners;
        },
        getScreeners(state) {
            return state.screeners;
        },
        getDataScreener(state) {
            return state.array_data_screener;
        },
        getSelectedScreenerFilters(state) {
            return state.screenerFilters;
        },
        getTemporaryFilterValues(state) {
            return state.temporaryFilterValues;
        },
        getOptionQorFY(state) {
            return state.optionQorFY;
        },
        getExchangeSelections(state) {
            return state.exchangeSelections;
        },
        getSectorSelections(state) {
            return state.sectorSelections;
        },
        getOrderOfColumns(state) {
            return state.orderOfColumns;
        }
    },

    mutations: {
        setUserScreeners(state, payload) {
            state.userScreeners = payload;
        },
        setScreeners(state, payload) {
            state.screeners = payload;
        },
        addScreener(state, payload) {
            state.screeners.push(payload);
        },
        setDataScreener(state, payload) {
            state.array_data_screener = payload;
        },
        setSelectedScreenerFilters(state, payload) {
            state.screenerFilters = payload;
        },
        setTemporaryFilterValues(state, payload) {
            state.temporaryFilterValues = payload;
        },
        setOptionQorFY(state, payload) {
            state.optionQorFY = payload;
        },
        setExchangeSelections(state, payload) {
            state.exchangeSelections = payload;
        },
        setSectorSelections(state, payload) {
            state.sectorSelections = payload;
        },
        setOrderOfColumns(state, payload) {
            state.orderOfColumns = payload;
        }
    },

    actions: {
        async loadScreenerData({ commit }) {
            const res = await ApiStocks.fetchAllStocks();
            commit("setDataScreener", res.data);
            return res.data;
        },
        async loadScreenerDataOnePage({ commit }) {
            const res = await ApiStocks.fetchOnePageStocks();
            commit("setDataScreener", res.data);
            return res.data;
        },
        async newUserScreenerFilters({ commit }, data) {
            await ApiService.saveUserScreenerFilters(data);

            const res = (await ApiService.getUserScreenerFilters(data.user_id)).data;

            commit("setUserScreeners", res);

            return res;
        },
        async editUserScreenFilters({ commit }, payload) {
            await ApiService.updateUserScreenerFilters(payload);

            const res = (await ApiService.getUserScreenerFilters(payload.user_id)).data;

            commit("setUserScreeners", res);

            return res;
        },
        async loadUserScreeners({ commit }, user_id) {
            const res = (await ApiService.getUserScreenerFilters(user_id)).data;

            commit("setUserScreeners", res);

            return res;
        },
        async deleteUserScreener({ commit }, payload) {
            await ApiService.deleteScreen(payload.screen_id);

            const res = (await ApiService.getUserScreenerFilters(payload.user_id)).data;

            commit("setUserScreeners", res);

            return res;
        },
        async editUserScreenColumnOrder({ commit }, payload) {
            await ApiService.updateUserScreenColumnOrder(payload);

            const res = (await ApiService.getUserScreenerFilters(payload.user_id)).data;

            commit("setUserScreeners", res);

            return res;
        },
    },
};
